ApiError = require 'network/api-error'
Auth = require 'db/auth'
Browser = require 'lib/browser'
l = require 'lib/localize'
Keyboard = require 'lib/keyboard'
localizeServerError = require 'lib/localize-server-error'
ModelLoader = require 'db/model-loader'
PopUpWindow = require 'views/lib/pop-up-window'
Promise = require 'bluebird'
t = require('views/internal/teacup-with-helpers')('invitation_link')
Util = require 'lib/util'
View = require 'view'
xtend = require 'xtend'
_ = require 'underscore'
$ = require 'jquery'

simpleDomainRestriction = (restriction) ->
  if /^\*@[^\*]+$/.test(restriction)
    restriction.replace(/^\*@/, '')
  else
    null

template = t.renderable ({ isLoggedIn, isConfirmed, isValidEmail, returnUrl, inviter, name, requiredDomain, firstDomain, emailRestrictions, pendingEmail, willJoinOnConfirm, transferUrl }) ->
  t.div '.invitation-link-description', ->
    t.format 'youve-been-invited',
      inviterName: inviter.fullName
      name: name

  if pendingEmail
    t.p '.invitation-link-explanation', ->
      t.format 'waiting-for-you-to-click-on-the-link-we-sent-to-email', { email: pendingEmail }

  else if isLoggedIn
    if !isValidEmail
      if requiredDomain
        t.p '.invitation-link-explanation', ->
          t.format 'to-join-this-team-you-need-to-confirm-an-email-from-domain', { domain: requiredDomain }

        t.h2 '.add-email-to-your-account-heading', ->
          t.format 'add-email-to-your-account'
        t.div '.invitation-link-add-email', ->
          t.input '.invitation-link-add-email-prefix.js-email-prefix-to-add', { placeholder: t.l('yourname'), 'data-domain': requiredDomain }
          t.span '.invitation-link-add-email-domain', ->
            t.text "@#{ requiredDomain }"

      else
        t.p '.invitation-link-explanation', ->
          t.format 'to-join-this-team-you-need-to-confirm-an-email-matching-one-of-the-following'
        t.ul ->
          for restriction in emailRestrictions
            t.li ->
              t.text restriction

        t.h2 '.add-email-to-your-account-heading', ->
          t.format 'add-email-to-your-account'
        t.div '.invitation-link-add-email', ->
          placeholder =
            if firstDomain
              t.l('yourname-at-domain', { domain: firstDomain })

          t.input '.invitation-link-add-email.js-email-to-add', { placeholder }

      t.div '.invitation-link-options', ->
        t.div ->
          t.a '.button.primary.js-add-email', { href: '#' }, ->
            t.format 'add-email'
        t.div '.invitation-link-switch-accounts', ->
          t.a '.quiet', { href: "/login?reauthenticate=1&returnUrl=#{ encodeURIComponent(returnUrl) }" }, ->
            t.format 'switch-accounts'

    else if isConfirmed
      t.div '.invitation-link-options', ->
        t.button '.button.primary.js-join', ->
          t.format 'join'
    else
      t.p '.invitation-link-explanation.js-you-need-to-confirm', ->
        t.format 'before-you-can-join-you-ll-need-to-confirm-your-email-address'

      if !willJoinOnConfirm
        t.p '.invitation-link-explanation.js-will-join-on-confirm.hide', ->
          t.format 'youll-be-added-as-soon-as-you-confirm-your-email'

        t.div '.invitation-link-options', ->
          t.button '.button.primary.js-join-on-confirm', ->
            t.format 'join-after-i-confirm-my-email'

  else
    t.p '.invitation-link-explanation', ->
      t.format 'before-you-can-join-you-ll-need-a-trello-account'

    if requiredDomain || emailRestrictions.length > 0
      if requiredDomain
        t.p ->
          t.format 'note-this-team-requires-you-log-in-with-an-email-from-domain', { domain: requiredDomain }
      else
        t.p ->
          t.format 'note-this-team-requires-you-log-in-with-an-email-matching-one-of-the-following'
        t.ul ->
          for restriction in emailRestrictions
            t.li ->
              t.text restriction

    t.div '.invitation-link-options', ->
      t.button '.button.primary.js-signup', ->
        t.format 'sign-up'
      t.button '.button.js-login', ->
        t.format 'log-in'

    t.div '.invitation-link-options-learn-more', ->
      t.a '.quiet', { href: '/tour', target: 'tour' }, ->
        t.format 'learn-more-about-trello'

  t.p '.error.js-deactivated.hide', ->
    t.format 'unfortunately-this-invitation-link-has-been-deactivated'

  t.p '.error.js-only-team-members.hide', ->
    t.format 'only-team-members-can-join-this-board'

  t.div '.error.js-must-join-enterprise.hide', ->
    t.p ->
      t.format 'before-you-can-join-this-team-you-must-join-the-enterprise-it-belongs-to'
    t.p ->
      t.a '.button.primary', { href: transferUrl }, ->
        t.format 'transfer-account'

  t.p '.error.js-error.hide', ->

  return

module.exports = class InvitationLinkView extends View
  className: 'invitation-link'
  events:
    'click .js-join': (e) ->
      @_disableJoin()
      @fxJoin()
      .catch ApiError.NotFound, (e) =>
        @$('.js-deactivated').removeClass('hide')
      .catch ApiError.Other, (e) =>
        if /organization restricts invites/.test(e.message)
          @$('.js-only-team-members').removeClass('hide')
        else
          throw e
      .catch ApiError.Conflict, (e) =>
        # We couldn't add them, we think because they need to
        # be part of the enterprise
        @$('.js-must-join-enterprise').removeClass('hide')
      .catch ApiError, (e) =>
        message = localizeServerError(e)
        # We couldn't add them, let them know why
        @$('.js-error').text(message).removeClass('hide')
      .done()
    'click .js-add-email': (e) ->
      @$('.js-email-to-add,.js-email-prefix-to-add').prop('disabled', true)
      @$('.js-add-email').prop('disabled', true).addClass('disabled')

      email = @_getEmail()
      @model.run 'logins', { email }, (err) =>
        @pendingEmail = email
        @render()
        return
    'input .js-email-to-add': 'updateButton'
    'input .js-email-prefix-to-add': 'updateButton'
    'keydown .js-email-prefix-to-add,.js-email-to-add': (e) ->
      if Keyboard.isSubmitEvent(e)
        @$('.js-add-email:not(:disabled)').click()
    'click .js-join-on-confirm': (e) ->
      @_queueAutoJoin()
      @$('.js-join-on-confirm,.js-you-need-to-confirm').addClass('hide')
      @$('.js-will-join-on-confirm').removeClass('hide')

    'click .js-signup': (e) ->
      @_queueAutoJoin()
      requiredDomain = @_requiredDomain()
      suggestedEmail =
        if requiredDomain
          t.l('yourname-at-domain', { domain: requiredDomain })
        else
          ''

      signUpUrl = "/signup?" + $.param
        returnUrl: if Browser.isEmbeddedDocument() then '/embed/signup' else @_returnUrl()
        confirmReturnUrl: @_returnUrl()
        email: suggestedEmail

      if Browser.isEmbeddedDocument()
        new PopUpWindow(signUpUrl).open()
      else
        window.location = signUpUrl

    'click .js-login': (e) ->
      @_queueAutoJoin()
      returnUrl = if Browser.isEmbeddedDocument() then '/embed/login' else @_returnUrl()
      loginUrl = "/login?" + $.param
        returnUrl: returnUrl

      if Browser.isEmbeddedDocument()
        new PopUpWindow(loginUrl).open()
      else
        window.location = loginUrl

  _disableJoin: ->
    @$('.js-join')
    .addClass('disabled')
    .prop('disabled', true)

  initialize: ({ @fxJoin, @fxQueueJoin, @inviter, @name, @emailRestrictions, @transferUrl, @willJoinOnConfirm }) ->
    # Do sort of the right thing if the user keeps this page open and goes
    # off to confirm their email … we assume they probably joined in the other
    # window.  If we refresh, we'll redirect to the right place, or at the
    # very least stop showing the "confirm your email" header
    if (me = Auth.me())?
      @listenTo me, 'change:confirmed change:logins', =>
        @$('.js-join')
        .addClass('disabled')

        setTimeout =>
          window.location.reload()
        , 1000

  updateButton: ->
    canAdd = @_isValidEmail(@_getEmail())
    @$('.js-add-email')
    .prop('disabled', !canAdd)
    .toggleClass('disabled', !canAdd)

  _queueAutoJoin: ->
    @fxQueueJoin()

  _getEmail: ->
    $email = @$('.js-email-to-add')
    $prefix = @$('.js-email-prefix-to-add')

    if $email.length
      $email.val()
    else if $prefix.length
      "#{ $prefix.val() }@#{ $prefix.attr('data-domain') }"

  _isValidEmail: (email) ->
    if @emailRestrictions.length == 0
      return true

    _.any @emailRestrictions, (restriction) ->
      ///^ #{ Util.escapeForRegex(restriction).replace(/\\\*/g, '[^@]*') } $///.test(email)

  _returnUrl: ->
    window.location.pathname

  _requiredDomain: ->
    @emailRestrictions.length == 1 &&
    simpleDomainRestriction(@emailRestrictions[0])

  render: ->
    me = Auth.me()
    isLoggedIn = Auth.isLoggedIn()
    isConfirmed = me?.get('confirmed')
    isValidEmail = isLoggedIn &&
      _.chain(me.get('logins'))
      .pluck('email')
      .any(@_isValidEmail.bind(@))
      .value()

    requiredDomain = @_requiredDomain()

    firstDomain = _.chain(@emailRestrictions)
      .map(simpleDomainRestriction)
      .compact()
      .first()
      .value()

    @$el.html template
      emailRestrictions: @emailRestrictions
      requiredDomain: requiredDomain
      firstDomain: firstDomain
      inviter: @inviter
      name: @name
      isConfirmed: isConfirmed
      isLoggedIn: isLoggedIn
      isValidEmail: isValidEmail
      pendingEmail: @pendingEmail
      returnUrl: @_returnUrl()
      transferUrl: @transferUrl
      willJoinOnConfirm: @willJoinOnConfirm

    @updateButton()

    @defer =>
      @$('.js-email-prefix-to-add,.js-email-to-add').focus().select()
    @



// WEBPACK FOOTER //
// ./app/scripts/views/invitation-link/invitation-link-view.coffee